// extracted by mini-css-extract-plugin
module.exports = {"sectionHeading":"SectionHeading-module--sectionHeading--3iZ3p"};